import styled from 'styled-components';
import { motion } from 'framer-motion';
import { min } from '../../../theme/breakpoints';

export const MusicGenreContainer = styled(motion.div)`
  overflow: hidden;
  background-color: ${({ theme }) => (theme.name === 'uplay' ? theme.colors.OuterSpace : theme.colors.Alabaster)};

  p,
  & {
    text-align: center;

    @media screen and ${min('largeTablet')} {
      text-align: left;
    }
  }
  > div {
    padding: 3.75rem 0;

    @media screen and ${min('largeTablet')} {
      padding: 5rem 0;
    }
  }
`;

export const Details = styled.p`
  color: ${({ theme }) => theme.colors.text};
  font-size: 1rem;
  margin-top: 1rem;

  @media screen and ${min('largeTablet')} {
    font-size: 1.125rem;
  }
`;

export const Caption = styled.p`
  color: ${({ theme }) => theme.colors.text};
  font-size: 0.75rem;
  margin-top: 1rem;

  @media screen and ${min('largeTablet')} {
    font-size: 0.875rem;
  }
`;

export const GenresList = styled.ul`
  margin: 0 -0.5rem 1rem;
  padding: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
`;
